<template>
    <div class="card card-basic card--blue card--activated h-auto">
        <div v-if="hasItems" class="card__text">
            <div class="d-flex flex-wrap mb-2">
                <span class="meeting-info color--blue font-italic">Datum</span>
                <span class="meeting-info color--blue font-italic">Groep</span>
                <span class="meeting-info color--blue font-italic">Tijd</span>
            </div>
            <meeting-Item
                v-for="(meetingItem, index) in items"
                :key="index"
                :meeting-item="meetingItem"
            />
        </div>
        <div v-if="!hasItems" class="card__text" v-html="altText"></div>
        <div class="card__bottom">
            <div class="card__bottom__button">
                <a :href="altLink">
                    <span class="card__bottom__button__content">
                        {{ altLinkText }}
                        <span
                            class="icon-angle-right card__bottom__button__content__icon"
                        >
                        </span>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import meetingItem from '@/components/meeting/meeting-item';
export default {
    components: {
        meetingItem
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        altText: {
            type: String,
            default() {
                return '';
            }
        },
        altLink: {
            type: String,
            default() {
                return '';
            }
        },
        altLinkText: {
            type: String,
            default: ''
        }
    },
    computed: {
        hasItems: function() {
            return this.items && this.items.length > 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.meeting-info {
    flex: 1 1 33.3333%;
    font-size: 20px;
    padding: 5px;
}
.card__bottom__button a {
    color: $brand-gray;
}
</style>
